import { useRef } from 'react';

const useLatest = (value) => {
  const valueRef = useRef(value);

  valueRef.current = value;

  return valueRef;
};

export default useLatest;
